<template>
	<div>
		<div v-for="(tr, index) in model" v-if="model.length > 0">
			<div style="background: #E34545;margin: 10px;padding-left: 7px;padding-top: 3px;padding-bottom: 3px;padding-right: 7px; float: right;color: white;font-weight: bold">
    			<span>{{tr.is_live ? getTranslatedText("LIVE") : getTranslatedText("Starts")}}</span><br><span class="text-small">{{tr.is_live ? getTranslatedText('Ends') : getTranslatedText('In')}}: <span :id="'tr_timer_' + tr.id"></span></span>
    		</div>
    		<div class="modal-dialog bg-light margin-7 radius-5" v-on:click="redirectTo('tournament', {partner: partnerID, contact_number: userPhone, user_name: userName, game_id: (tr.game_web_id || tr.game_id), lang: langCode})">
    			<div id="banner">
			    <div v-if="tr.image_url.length" class="banner-image radius-5" :style="{'background-image': 'url(' + tr.image_url + ')', 'background-size': 'contain'}"></div>
			    <div class="full-width align-hor center-hor" v-else>
			      <div class="wrapper animate radius-5 banner-image full-width"></div>
			    </div>
			  </div>
    		</div>
	    </div>

	    <div v-if="model == null || model.length == 0" class="noTournament"><span>No Tournaments Live</span></div>
	</div>
</template>
<script>
	import { globals } from "@/mixins/globals"
	export default {
		mixins: [globals],
	    props: {
	      model: Array
	    }
	}
</script>
<style>
	#banner {
		height: auto;
		padding: 7px;
	}
	.banner-image {
		height: 160px;
		width: 100%;
	}

	.noTournament {
		margin-top: 20px;
	}
</style>